import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * @author willpanyang
 * @version 1.0.0.0
 * @class milo.ams.cdkey.CdkeyExchage
 * cdkey兑换<br/>
 * 改自adrianasun的原LotteryManager<br/>
 * @demo 暂无
 */
import FlowEngine from '../../amsRequest/flowengine';
import ams from '../../common/ams';
import cookie from '../../common/cookie';
var defaultOption = {
  isAutoLoad: false,
  // 是否自动加载。
  activityId: '',
  // 活动的ID
  changeVerifyImgId: 'changeVerifyImg',
  // 刷新验证码ID
  verifyCodeId: 'verifyCode',
  // 验证码ID
  gameId: '',
  fFlowSubmitEnd: null,
  fFlowSubmitFailed: null,
  sCdKey: '',
  // cdkey, 用户输入
  iUin: '',
  sVerifyCode: '',
  // 验证码, 用户输入
  iVerifyId: '21000104',
  verifysession: cookie.get('verifysession')
};

var getConfig = function getConfig(opt) {
  var iActivityId = opt.iActivityId,
      iFlowId = opt.iFlowId,
      flowConfig = opt.flowConfig;
  return ams.amsInit(iActivityId, iFlowId, flowConfig).then(function (_ref) {
    var config = _ref.config;

    // 登录检查
    var _ref2 = config || {},
        _ref2$sData = _ref2.sData,
        sData = _ref2$sData === void 0 ? {} : _ref2$sData;

    var option = _objectSpread(_objectSpread(_objectSpread({}, defaultOption), config), sData);

    return option;
  });
};

var _submitCDKExchange = function _submitCDKExchange(option) {
  return new Promise(function (resolve, reject) {
    var sData = option.sData,
        sCdKey = option.sCdKey,
        sVerifyCode = option.sVerifyCode,
        verifysession = option.verifysession,
        iAMSActivityId = option.iAMSActivityId,
        iFlowId = option.iFlowId,
        withRoleInfo = option.withRoleInfo;
    var submitOption = {
      sCdKey: sCdKey,
      // iUin: LoginManager.getUserUin(),
      sVerifyCode: sVerifyCode,
      isVerifyCode: true,
      verifysession: verifysession,
      iVerifyId: '21000104'
    };
    submitOption = _objectSpread(_objectSpread(_objectSpread({}, submitOption), sData), {}, {
      sArea: sData && sData.sArea || ''
    }); // 使用AMS方式提交请求

    var FlowSubmitJson = {
      iActivityId: iAMSActivityId,
      // AMS活动号
      iFlowId: iFlowId,
      // 抽奖流程ID
      sData: submitOption,
      withRoleInfo: withRoleInfo
    };
    FlowEngine.submit(FlowSubmitJson).then(function (exchangeCdkObj) {
      if (exchangeCdkObj) {
        resolve(exchangeCdkObj);
      } else {
        reject({
          iRet: '-8000',
          sMsg: '网络连接异常，请刷新重试。'
        });
      }
    })["catch"](function (err) {
      reject(err);
    });
  });
};

export default function exchangeCdkey(opt) {
  return getConfig(opt).then(function (option) {
    var errMsg = ''; // 检查CDK长度

    option.sCdKey = option.sCdKey.replace(/^\s+|\s+$/g, '');

    if (option.sCdKey.length <= 0) {
      errMsg = 'cdk不能为空！';
      throw {
        errMsg: errMsg
      };
    }

    if (option.sCdKey.length != 16 && option.sCdKey.length != 18) {
      errMsg = 'cdk格式不正确！';
      throw {
        errMsg: errMsg
      };
    } // 校验验证码


    option.sVerifyCode = option.sVerifyCode.replace(/^\s+|\s+$/g, '');

    if (!option.sVerifyCode) {
      errMsg = '您的验证码信息未输入。';
      throw {
        errMsg: errMsg
      };
    }

    if (option.sVerifyCode.length != 4) {
      errMsg = '您的验证码信息填写出错。';
      throw {
        errMsg: errMsg
      };
    }

    return _submitCDKExchange(option);
  });
}